import { createSelector } from '@ngrx/store';
import { CoreState } from '../reducers';
import { getEntities, getLoading } from '../reducers/shipper-user.reducer';

export const getShipperUserState = (state: CoreState) => state.shipperUserState;

export const getShipperUsers = createSelector(getShipperUserState, getEntities);
export const getLoadingShipperUsers = createSelector(getShipperUserState, getLoading);
